
<div class="px-0 mx-0 container-fluid">
    <app-navbarback></app-navbarback>
    <router-outlet></router-outlet>
</div>